import { closingOf } from './classNames'

export const withAttrib = (attribName: string): string => `[${attribName}]`

export const withClass = (className: string): string => `.${className}`

export const withClasses = (classNames: string[]): string =>
  classNames.map(className => withClass(className)).join('')

export const withClosingClassOf = (className: string): string =>
  `.${closingOf(className)}`

export const selectorsOr = (selectors: string[]): string =>
  selectors.join(', ')

export const withSelectorHierarchy = (selectors: string[]): string =>
  selectors.join(' ')

export const withClassHierarchy = (classNames: string[]): string =>
  withSelectorHierarchy(classNames.map(className => withClass(className)))
